import { render, staticRenderFns } from "./PotentialDownload.vue?vue&type=template&id=395b7a1c&scoped=true&"
import script from "./PotentialDownload.vue?vue&type=script&lang=js&"
export * from "./PotentialDownload.vue?vue&type=script&lang=js&"
import style0 from "./PotentialDownload.vue?vue&type=style&index=0&id=395b7a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b7a1c",
  null
  
)

export default component.exports